import { apiClient } from './client';

export interface PresetResponse {
  id: number;
  name: string;
  content: string;
  user_id: number | null;
  created_at: string;
  updated_at: string;
}

export interface PresetsListResponse {
  nodes: PresetResponse[];
  total: number;
}

export const presetsApi = {
  list: () => apiClient.get<PresetsListResponse>('/api/presets'),

  create: (data: { name: string; content: string }) =>
    apiClient.post<PresetResponse>('/api/presets', data),

  remove: (presetId: number) => apiClient.delete(`/api/presets/${presetId}`),
};
